import { render, staticRenderFns } from "./FormCrudPaper.vue?vue&type=template&id=7a7c51b4"
import script from "./FormCrudPaper.vue?vue&type=script&lang=js"
export * from "./FormCrudPaper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports